<script>
import formatDate from '@utils/format-date'
import NewsItem from '@components/List/NewsItem'

export default {
  components: {
    NewsItem,
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    isRowItem: {
      type: Boolean,
      default: false,
    },
    isVideo: {
      type: Boolean,
      default: false,
    },
    contentType: {
      type: String,
      default: 'news',
      validator(value) {
        return ['news', 'video'].includes(value)
      },
    },
  },
  data() {
    return {
      formatDate,
    }
  },
  methods: {
    onPlay(id) {
      this.visibleVideoDialog = true
      this.$nextTick(() => {
        this.$emit('play', id)
      })
    },
    // eventDate(extrafields) {
    //   if(!extrafields) {
    //     return '即日開始'
    //   }

    //   const { register_start: { value: start }, register_end: { value: end } } = extrafields
    //   if(start === null && end === null) {
    //     return '即日開始'
    //   }
    //   if(start && end) {
    //     return `${ formatDate(start, 'yyyy/MM/dd') } 至 ${ formatDate(end, 'yyyy/MM/dd') }`
    //   }
    //   if(start === null && end) {
    //     return `即日起至 ${ formatDate(end, 'yyyy/MM/dd') }`
    //   }
    //   if(start && end === null) {
    //     return `${ formatDate(start, 'yyyy/MM/dd') }開始`
    //   }

    //   return '無'
    // },
    goToView(val) {
      this.$emit('goTo', val)
    },
  },
}
</script>
<template>
  <div class="row" :class="$style.news">
    <div v-for="(item, $index) in list" :key="$index" :class="{ 'col-lg-6': !isRowItem, 'col-12': isRowItem }">
      <NewsItem :item="item" :is-row-item="isRowItem" :is-video="isVideo" :content-type="contentType" class="news__item" @goTo="goToView" />
      <!-- <router-link :to="item.to" class="default-link">
        <div
          :class="[$style.newsItem, { 'isRowItem': isRowItem, 'item-hover-shadow': !isRowItem, 'item-only-hover-shadow': isRowItem }]">
          <template v-if="item.videoId">
            <div
              class="newsItem__video"
              @click="onPlay(item.videoId)"
            >
              <youtube
                ref="youtube"
                :video-id="item.videoId"
                class="newsItem__youtube"
              ></youtube>
            </div>
          </template>
          <template v-else>
            <div class="newsItem__img clip-img-wrapper align-self-lg-center">
              <img v-if="item.introimage" class="clip-img" :src="item.introimage" alt=""/>
              <img v-else class="clip-img" :src="require('@src/assets/images/news/item.jpg')" alt="">
            </div>
          </template>
          <div class="newsItem__content">
            <div class="newsItem__info">
              <img v-if="item.brands.logo_image" class="newsItem__logo" :src="item.brands.logo_image" alt=""/>
              <template v-if="item.isdealer">
                <span class="badge  d-lg-block d-none"> 經銷商限定 </span>
              </template>
            </div>
            <h4 class="newsItem__title mb-2">{{ item.title }}</h4>
            <p v-if="isRowItem">{{ item.introtext }}</p>
            <div class="text-small-2 mt-auto pb-md-2 d-lg-block d-none">
              <i class="far fa-clock"></i>
              <template v-if="item.videoId">
                {{ formatDate(item.publish_up) }}
              </template>
              <template v-else>
                {{ eventDate(item.extrafields) }}
              </template>
            </div>
            <div  v-if="item.isdealer" class="text-small-2 mt-auto pb-md-2">
                <span class="badge d-lg-none"> 經銷商限定 </span>
            </div>
          </div>
        </div>
      </router-link> -->
    </div>
  </div>
</template>
<style lang="scss" module>
.news {
  // margin-top: -1.5rem;
  :global {
    .news {
      &__item {
        margin-bottom: 2rem;
      }
    }
  }
}

// .newsItem {
//   display: flex;
//   padding: 2.5rem;
//   margin-bottom: 2rem;
//   color: $color-gray-6;
//   background-color: #FFF;
//   transition: all 0.35s;

//   @include max-lg {
//     // display: block;
//     padding: 0;
//     border-radius: 5px;
//     overflow: hidden;
//   }

//   &:hover {
//     color: $color-gray-7;
//     text-decoration: none;
//   }

//   .clip-img-wrapper {
//     @include min-md {
//       padding-top: 27.5%;
//     }
//   }

//   :global {
//     .newsItem {
//       &__img {
//         position: relative;
//         z-index: 0;
//         width: 25%;
//         cursor: pointer;
//         background: #EEE;
//         background-position: center;
//         background-size: cover;

//         @include max-lg {
//           width: 28%;
//         }
//         // width: 96px;
//         // height: 96px;
//         // padding-top: 30% !important;

//         // @include min-md {
//         //   width: 25%;
//         //   padding-top: 25% !important;
//         // }
//       }

//       &__video {
//         position: relative;
//         width: 61%;
//         padding-top: 25%;
//         background-color: $color-gray-2;
//         background-size: cover;

//         @include max-lg {
//           width: 100%;
//           padding-top: 56%;
//         }
//       }

//       &__youtube {
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//       }

//       &__content {
//         display: flex;
//         flex-direction: column;
//         width: 75%;
//         // width: 50%;
//         padding-left: 2.4rem;

//         @include max-lg {
//           // width: 100%;
//           padding: 1rem 0.75rem 1.1875rem 0.75rem;
//           width: 72%;
//           // margin-top: 1rem;
//         }
//       }

//       &__logo {
//         height: 40px;

//         @include max-lg {
//           height: 28px;
//         }
//       }

//       &__title {
//         width: 100%;
//         font-size: 1.35rem;
//         line-height: 1.5;
//         color: $color-gray-7;

//         @include line-clamp(2, 3em);

//         @include max-lg {
//           font-size: 1rem;
//         }
//       }

//       &__info {
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         width: 100%;
//         // margin-bottom: 0.8rem;
//         height: 50px;
//         @include max-lg {
//           height: 30px;
//         }
//       }
//     }

//     .clip-img-wrapper {
//       position: relative;
//       height: 0;
//       padding-top: 50%;
//       padding-top: 25%;
//       @include max-lg {
//         padding-top: 28%;
//       }
//     }

//     .clip-img {
//       position: absolute;
//       object-fit: cover;
//       top: 0;
//       width: 100%;
//       height: 100%;
//       object-position: center center;
//     }
//     .badge {
//       @include max-lg {
//         padding: 0.5rem;
//         font-size: 12px;
//       }
//     }
//   }

//   &:global {
//     &.isRowItem {
//       .newsItem__content {
//         padding-left: 4.5rem;
//         margin: 0 0 0.5rem 0;

//         @include max-md {
//           padding-left: 0;
//         }
//       }

//       .newsItem__title {
//         font-size: 1.875rem;

//         @include max-lg {
//           font-size: 1rem;
//         }
//       }
//     }
//   }
// }
</style>
